import React, { useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/Controls.module.scss'

const Controls = ({ children, data, collapsed, onToggle }) => {
  const [status, setStatus] = useState('')

  const timer = useRef(null)

  const toggle = useCallback(() => {
    setStatus('toggling')
    onToggle()

    timer.current && clearTimeout(timer.current)
    timer.current = setTimeout(() => 'toggling' === status && setStatus(''), 500)

    return () => timer.current && clearTimeout(timer.current)
  }, [status, onToggle])

  return (
    <div className={`${style.component} p-fluid`}>
      {data.icon && (
        <div className={`${style.icon} p-field`}>
          <i className={data.icon.class} />
          <span dangerouslySetInnerHTML={{ __html: data.icon.text }}></span>
        </div>
      )}
      <div className={`${style.controls} p-fluid p-field p-right p-col`}>{children}</div>
      <div className="p-field p-right">
        <span
          className={`${style.toggle} ${
            'toggling' == status ? (collapsed ? style['toggle-spin-reverse'] : style['toggle-spin']) : ''
          }`}
        >
          <i className="icon-aytmfd-config" onClick={toggle} />
        </span>
      </div>
      {data.help && (
        <div className={`${style.help} p-field p-right`}>
          <Popup
            trigger="click"
            width="500px"
            direction="bottomright"
            popupOffset={14}
            hideOtherPopupsOnShow
            content={() => <div dangerouslySetInnerHTML={{ __html: data.help }}></div>}
          >
            <i className="icon-aytmfd-help" />
          </Popup>
        </div>
      )}
    </div>
  )
}

Controls.propTypes = {
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.any
}

Controls.displayName = 'Controls'

export default Controls
